import { render, staticRenderFns } from "./sctz38SeatPlan.vue?vue&type=template&id=b3bff6ce&scoped=true&"
import script from "./sctz38SeatPlan.vue?vue&type=script&lang=js&"
export * from "./sctz38SeatPlan.vue?vue&type=script&lang=js&"
import style0 from "./sctz38SeatPlan.vue?vue&type=style&index=0&id=b3bff6ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bff6ce",
  null
  
)

component.options.__file = "sctz38SeatPlan.vue"
export default component.exports